import React from 'react'
import NavBar from './navbar'

export default () => {
  return <NavBar />
}



// WEBPACK FOOTER //
// ./src/components/navbar/index.js